// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: white;
}
.container{
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding:0;
    padding-left:4%; 
    padding-right: 4%; 

    background-color: white;
}
.container{
    width: 100%;
    max-width: 100%;
    background-color:whitesmoke;
    padding:0;
    padding-left:4%; 
    padding-right: 4%; 

    background-color: white;
}

.my-Delegation-header{
    background-color: #fff;

}

.my-Delegation-container {
    border: 2px solid #286090;
    width: 100%;
    margin: 5% auto;
    border-radius: 10px;
    background-color: #fff;
    padding-bottom:2% auto;
}

.my-Delegation-select-text {
    color: white;
    padding: 10px;
    background-color: #0B2D71;
    text-align: left;
    border-radius: 5px 5px 0 0;
}
.button-container {
    display: flex;
    gap: 10px; /* Adjust the gap as needed */
    margin-bottom: 10px; /* Space between buttons and table */
}

.bulk-button {
    background-color: #286090;
    color: white;
    border : none;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
}
.bulk-button.approve {
    margin-left: 20px; 
}
/* Modal styles */
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  
  /* OK button styles */
  #closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  
  #closeSuccessModal:hover {
    background-color: #0056b3;
  }
  .red-icon {
    color: red;
}
.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 150px; /* Adjust as needed */
}
.allignment{
    text-align: center;
}
.center-content {
    margin: auto !important;
    text-align: center;
}
.table-padding{
    margin: 1%;
}
.loading-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10px;
  }
  
  :host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
  }`, "",{"version":3,"sources":["webpack://./src/app/report/mydelegation/mydelegation.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,iBAAiB;;IAEjB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,iBAAiB;;IAEjB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,SAAS,EAAE,6BAA6B;IACxC,mBAAmB,EAAE,oCAAoC;AAC7D;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,iBAAiB;AACrB;AACA,iBAAiB;AACjB;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;EAC9E;;;EAGA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB,EAAE,qBAAqB;AAC3C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,wEAAwE;EAC1E","sourcesContent":["body {\n    background-color: white;\n}\n.container{\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding:0;\n    padding-left:4%; \n    padding-right: 4%; \n\n    background-color: white;\n}\n.container{\n    width: 100%;\n    max-width: 100%;\n    background-color:whitesmoke;\n    padding:0;\n    padding-left:4%; \n    padding-right: 4%; \n\n    background-color: white;\n}\n\n.my-Delegation-header{\n    background-color: #fff;\n\n}\n\n.my-Delegation-container {\n    border: 2px solid #286090;\n    width: 100%;\n    margin: 5% auto;\n    border-radius: 10px;\n    background-color: #fff;\n    padding-bottom:2% auto;\n}\n\n.my-Delegation-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0B2D71;\n    text-align: left;\n    border-radius: 5px 5px 0 0;\n}\n.button-container {\n    display: flex;\n    gap: 10px; /* Adjust the gap as needed */\n    margin-bottom: 10px; /* Space between buttons and table */\n}\n\n.bulk-button {\n    background-color: #286090;\n    color: white;\n    border : none;\n    border-radius: 5px;\n    padding: 10px 20px;\n    cursor: pointer;\n}\n.bulk-button.approve {\n    margin-left: 20px; \n}\n/* Modal styles */\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n  }\n  \n  .modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 500px;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  }\n  \n  \n  /* OK button styles */\n  #closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n  }\n  \n  #closeSuccessModal:hover {\n    background-color: #0056b3;\n  }\n  .red-icon {\n    color: red;\n}\n.truncate {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 150px; /* Adjust as needed */\n}\n.allignment{\n    text-align: center;\n}\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n.table-padding{\n    margin: 1%;\n}\n.loading-spinner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 10px;\n  }\n  \n  :host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
